import { object, string } from 'yup';

import { messages, trim } from '../../../data/utils/form.utils';

/**
 * Rejecting is not a silent close: the practice owes the household a reason,
 * and the server stores it on the registration. Required, not an optional
 * note.
 */
export const schema = object()
  .shape({
    reason: string()
      .transform(trim)
      .max(500, messages.maxLength.id)
      .required(messages.required.id)
      .default(''),
  })
  .required()
  .noUnknown();
